import get from 'lodash.get';
import PropTypes from 'prop-types';
import PaypalLogo from 'dibs-icons/exports/legacy/PaypalLogo';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import styles from './styles/checkoutPayPalView.scss';

const CheckoutPayPalView = ({ payPalAccount, hideName = false }) => {
    const displayName = get(payPalAccount, 'displayName');
    const email = get(payPalAccount, 'email');
    return (
        <div>
            <PaypalLogo className={styles.logo} />
            {!hideName && !!displayName && <div>{displayName}</div>}
            <p>{email}</p>
        </div>
    );
};

CheckoutPayPalView.propTypes = {
    payPalAccount: PropTypes.object,
    hideName: PropTypes.bool,
};

export default createFragmentContainer(CheckoutPayPalView, {
    payPalAccount: graphql`
        fragment CheckoutPayPalView_payPalAccount on PayPalAccount {
            displayName
            email
        }
    `,
});
